import { AbTestName, AbTestReturn, abTests } from '@beconfident/api-lib';
import posthog from 'posthog-js';

export default function getAbTest<T extends AbTestName>(
  testName: T,
): AbTestReturn<T> {
  const featureFlag = posthog.getFeatureFlag(testName);
  const test = abTests[testName];

  if (test.kind === 'multiple') {
    return featureFlag as AbTestReturn<T>;
  }

  return posthog.isFeatureEnabled(testName) as AbTestReturn<T>;
}
